var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.dialogVisible, width: "760px" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "box-content-head" }, [
          _c(
            "p",
            {
              staticClass: "font16 colorfff",
              staticStyle: { "font-size": "16px" },
            },
            [_vm._v("欢迎使用匿名识别")]
          ),
          _c(
            "p",
            {
              staticClass: "font12 colorfff",
              staticStyle: { "font-size": "12px" },
            },
            [
              _vm._v(
                "将追踪代码粘贴到您的网站上，即可识别出匿名访客背后的企业，让您与客户更进一步！"
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "box-content" }, [
          _c("p", { staticClass: "a1" }, [_vm._v("让我们开始吧!")]),
          _c("div", { staticClass: "steps a2" }, [
            _c("div", { staticClass: "b1" }, [_vm._v("01")]),
            _vm._v(
              " 为了让「匿名识别」能捕获您的网站访问者的信息，您需要将追踪代码放入页面的Html Body标签中"
            ),
          ]),
          _c("div", { staticStyle: { "padding-left": "34px" } }, [
            _c("div", { staticClass: "copyarea", attrs: { id: "copyText" } }, [
              _vm._v(_vm._s(_vm.content)),
            ]),
          ]),
          _c("div", { staticStyle: { "padding-left": "34px" } }, [
            _c("div", { staticClass: "fixedClass" }, [
              _c(
                "a",
                {
                  staticClass: "color3987EA",
                  staticStyle: { color: "#5088FF", "font-size": "14px" },
                  attrs: { href: "/zxk/junbros/codeExplain" },
                },
                [_vm._v("查看安装说明")]
              ),
              _c("span", { staticClass: "btn", on: { click: _vm.clickCopy } }, [
                _vm._v("复制"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "steps a2" }, [
            _c("div", { staticClass: "b1" }, [_vm._v("02")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "添加代码后，一键检测代码是否安装成功.安装成功后，您将看到奇妙的事情，发现网站流量背后的秘密！"
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "h1", staticStyle: { "padding-left": "34px" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "https://www.71360.com/" },
                  model: {
                    value: _vm.TestmainUrl,
                    callback: function ($$v) {
                      _vm.TestmainUrl = $$v
                    },
                    expression: "TestmainUrl",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "font-size": "14px", height: "36px" },
                      attrs: { slot: "append", type: "primary" },
                      on: { click: _vm.clickCheck },
                      slot: "append",
                    },
                    [_vm._v("点击检测")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { "padding-left": "18px" } }, [
            _c("div", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                "element-loading-spinner": "el-icon-loading",
                "element-loading-text": "检测过程需要一点时间，请待心等待！",
              },
            }),
          ]),
        ]),
        _c("ul", { staticClass: "intro" }, [
          _c("p", { staticClass: "a1" }, [_vm._v("如何排除故障？")]),
          _c("li", { staticStyle: { "margin-top": "6px" } }, [
            _vm._v(
              "1.至少等待1天，以查看系统是否已收集了访客数据，如果您的网站流量较低（日均IP1000以内），这点尤其重要。"
            ),
          ]),
          _c("li", [
            _vm._v("2.检查并确保提供给您的追踪代码已粘贴到有流量的网页中。"),
          ]),
          _c("li", [_vm._v("3.检查并确保代码已放入页面的HTML BODY标签中。")]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }